import { Injectable } from '@angular/core';
import { IAuditLog } from './audit-log.interface';
import { FirestoreRulesService } from '../core/firestore-rules/firestore-rules.service';
import { updatedDiff } from 'deep-object-diff';
import { ActionTypeEnum } from './action-type.enum';
import { EntityTypeEnum } from './entity-type.enum';
import { LocalStorageService } from '../core/local-storage/local-storage.service';
import { LocalStorageKeys } from '../core/local-storage/local-storage.enum';
import { ILecture } from '../views/pages/lectures/lecture.interface';

@Injectable({
    providedIn: 'root'
})

export class AuditLogService {

    constructor(private readonly firestoreRulesService: FirestoreRulesService,
                private readonly localStorageService: LocalStorageService) {}

    getAllAuditLogs(): Promise<IAuditLog[]> {
        return new Promise<IAuditLog[]>(async (resolve, reject) => {
            try {
                const docs = await this.firestoreRulesService.getAllAuditLogs();
                resolve(docs as IAuditLog[]);
            } catch (error) {
                reject(error);
            }
        });
    }

    getAllAuditLogsByEntity(uid: string, entityType: EntityTypeEnum): Promise<unknown> {
        // if uid is provided then get audit logs by entity id
        // else get audit logs by entity type
        return new Promise<unknown>(async (resolve, reject) => {
            let docs;
            try {
                if (uid) {
                    docs = await this.firestoreRulesService.getAuditLogsByEntityId(uid);
                } else {
                    docs = await this.firestoreRulesService.getAuditLogsByEntityType(entityType);
                }
                resolve(docs);
            } catch (error) {
                reject(error);
            }
        });
    }

    addLectureAuditLog(docId: string, actionType: ActionTypeEnum, lecture: ILecture, origLecture?: ILecture): Promise<void> {
        let doc = this.convertDataToAuditLog(docId, actionType, EntityTypeEnum.LECTURES);
        if (actionType === ActionTypeEnum.UPDATED && origLecture) {
            // Log diffs
            doc = this.difference(doc, lecture, origLecture);
        }
        return this.firestoreRulesService.addAuditLog(doc);
    }

    addUserAuditLog(doc: IAuditLog): Promise<void> {
        doc.entityType = EntityTypeEnum.USERS;
        return this.firestoreRulesService.addAuditLog(doc);
    }

    private difference(doc: IAuditLog, origObj, updObj): any{
        const diff = updatedDiff(origObj, updObj) as any;
        delete diff.updated_at;
        doc.newValue = (diff as any);
        doc.oldValue = this.getOrigFromDiff(origObj, diff);
        return doc;
    }

    private getOrigFromDiff(origObj, diff): any{
        const oldValue: any = {};
        for (const key of Object.keys(diff)) {
            oldValue[key] = origObj[key];
        }
        return oldValue;
    }

    private convertDataToAuditLog(entityId: string, actionType: ActionTypeEnum, entityType: EntityTypeEnum): IAuditLog {
        let uid = '';
        let displayName = '';
        if (actionType !== ActionTypeEnum.CREATED) {
            const currentUser = JSON.parse(this.localStorageService.read(LocalStorageKeys.currentUser));
            uid  = currentUser ? currentUser.uid : '';
            displayName = currentUser ? currentUser.displayName : '';
        }

        return {
        actionDate: new Date(),
        userDisplayName: displayName,
        userUID: uid,
        actionType,
        entityType,
        entityId
        };
    }


}
